import { z } from 'zod';

const requiredMessage = 'Birthday (MM/DD/YYYY) is required';
const invalidMessage = 'Please enter a valid date in the format MM/DD/YYYY';
const invalidYearMessage = 'Year must be later than 1969';
const futureDateMessage = 'Date cannot be in the future';
const gotchaDayBeforeBirthdayMessage = 'Date cannot be earlier than the birthday';

const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;

const isValidCalendarDate = (date: Date, month: number, day: number, year: number) =>
    date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

export const birthDateSchema = z
    .string({
        message: requiredMessage,
    })
    .superRefine((value, ctx) => {
        if (!value) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: requiredMessage,
            });
            return;
        }

        const [month, day, year] = value.split('/').map(Number);

        if (year < 1970) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: invalidYearMessage,
            });
            return;
        }

        if (!datePattern.test(value)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: invalidMessage,
            });
            return;
        }

        const date = new Date(year, month - 1, day);

        if (!isValidCalendarDate(date, month, day, year)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: invalidMessage,
            });
            return;
        }

        if (date.getTime() > Date.now()) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: futureDateMessage,
            });
        }
    });

export const gotchaDaySchema = (birthday?: Date) =>
    z
        .string()
        .optional()
        .superRefine((value, ctx) => {
            if (!value) return;

            if (!datePattern.test(value)) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: invalidMessage });
                return;
            }

            const [month, day, year] = value.split('/').map(Number);
            const date = new Date(year, month - 1, day);

            if (!isValidCalendarDate(date, month, day, year)) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: invalidMessage });
                return;
            }

            if (date.getTime() > Date.now()) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: futureDateMessage });
                return;
            }

            if (birthday && date < birthday) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: gotchaDayBeforeBirthdayMessage });
            }
        });
